import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import styled from 'styled-components';
import tw from 'twin.macro';
import BurgerButton from './BurgerButton';
import useWindowSize from '../utils/useWindowSize';

export const StyledNavbar = styled.ul`
  color: inherit;
  transition: all 150ms ${(p) => p.theme.easing};
  color: ${(p) => p.theme.color.white};
  background: ${(p) => p.theme.color.background};
  ${tw`
    absolute sm:relative flex flex-auto flex-col sm:flex-row sm:justify-end 
    text-xl font-bold mt-10 sm:m-0 w-full z-50 self-stretch opacity-100 
    translate-y-full sm:translate-y-0 left-0 
  `};
`;

export const NavItem = styled.li`
  ${tw`flex flex-initial items-stretch`}
`;

export const NavLink = styled(({ children, navOpen, ...styleProps }) => (
  <Link
    data-a11y="false"
    tabIndex={navOpen ? '0' : '-1'}
    activeClassName="active"
    {...styleProps}
  >
    <span>{children}</span>
  </Link>
))`
  ${tw`
    flex flex-auto items-center py-4 px-3 text-center no-underline sm:leading-none
    opacity-50 focus:opacity-100 hover:opacity-100 overflow-visible z-10
  `}
  transition: all 150ms ${(p) => p.theme.easing};

  &:hover,
  &:active,
  &.active {
    opacity: 1;
  }

  span {
    ${tw`
      block w-full
    `}
  }
`;

NavLink.defaultProps = {
  navOpen: true,
};

const Motion = styled(motion.div)`
  ${tw`flex`}
`;


const Navbar = ({ menu }) => {
  const [navOpen, setNavOpen] = useState(false);
  const toggleNavOpen = () => {
    setNavOpen(!navOpen);
  };
  const size = useWindowSize();
  const menuVariants = {
    open: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: size.width <= 648 ? 0 : -300 },
  };

  return (
    <Motion initial="hidden" animate={navOpen ? 'open' : 'hidden'}>
      <Motion variants={menuVariants}>
        <StyledNavbar id="header-menu">
          {menu.menuItems.map((item) => (
            <NavItem key={item.label}>
              <NavLink
                onClick={toggleNavOpen}
                navOpen={navOpen}
                partiallyActive={item.link !== '/'}
                to={item.link}
              >
                {item.label}
              </NavLink>
            </NavItem>
          ))}
        </StyledNavbar>
      </Motion>
      <Motion initial={{ rotate: 0 }} animate={{ rotate: navOpen ? 90 : 0 }}>
        <BurgerButton aria-label="Toggle Nav" handleClick={toggleNavOpen} />
      </Motion>
    </Motion>
  );
};

export default Navbar;
